/**
 * AdminLayout Component
 * Main layout for admin pages
 */

import { useState } from "react";
import { Link } from "react-router-dom";

import { useAuth } from "../../context/AuthContext";
import { CollectionForm } from "./CollectionForm";
import { CollectionList } from "./CollectionList";

export function AdminLayout() {
  const [showNewCollectionForm, setShowNewCollectionForm] = useState(false);
  const { user, logout } = useAuth();

  return (
    <div className="flex flex-col h-full max-w-6xl mx-auto p-4">
      {/* Header */}
      <div className="text-on-surface mb-6 flex justify-between items-center">
        <div>
          <h1 className="text-3xl font-bold mb-2">🐺 Admin - Collecties</h1>
          <p className="text-on-surface-variant">Beheer collecties en documentverwerking</p>
          {user && (
            <p className="text-on-surface-variant text-sm mt-1">Ingelogd als: {user.name}</p>
          )}
        </div>
        <div className="flex gap-3">
          <Link
            to="/"
            className="bg-surface-container hover:bg-surface-container-high border border-outline-variant px-4 py-2 rounded-md text-sm font-medium transition-colors"
          >
            ← Terug naar Akela
          </Link>
          <button
            onClick={logout}
            className="bg-surface-container hover:bg-surface-container-high border border-outline-variant px-4 py-2 rounded-md text-sm font-medium transition-colors"
          >
            Uitloggen
          </button>
          <button
            onClick={() => setShowNewCollectionForm(!showNewCollectionForm)}
            className="bg-primary hover:brightness-110 text-on-primary px-4 py-2 rounded-md text-sm font-semibold transition-colors shadow-2"
          >
            {showNewCollectionForm ? "✕ Annuleer" : "+ Nieuwe Collectie"}
          </button>
        </div>
      </div>

      {/* New Collection Form */}
      {showNewCollectionForm && (
        <div className="mb-6">
          <CollectionForm
            onSuccess={() => setShowNewCollectionForm(false)}
            onCancel={() => setShowNewCollectionForm(false)}
          />
        </div>
      )}

      {/* Collection List */}
      <CollectionList />
    </div>
  );
}
